import { FullCircularLoader } from "components/core";
import { onAuthStateChanged } from "firebase/auth";
import Layout from "layouts";
import { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { getTimeOutTime } from "services/api/query";
import useAuthService from "services/authService";
import { authentication } from "services/firebase";
import { removeAuthInfo, selectAuth } from "store/slices";
import { inactivityWarningTimeInSec } from "utils/constants";
import { LOGIN } from "./Paths";

function ProtectedRoute() {
  const dispatch = useDispatch();
  const authService = useAuthService();
  const { auth, isError } = useSelector(selectAuth);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      authentication,
      async (currentUser) => {
        // check whether the user have an existing session
        if (currentUser) {
          const lastActivityStr = localStorage.getItem("lastActivity");

          if (lastActivityStr) {
            const lastActivity = parseInt(lastActivityStr, 10);
            const now = Date.now();
            const time = await getTimeOutTime();
            const minutes = time
              ? Number(time)
              : Number(process.env.REACT_APP_TIMEOUT_IN_MIN);
            const TIMEOUT_MS = minutes * 60 * 1000;
            const WARNING_DURATION_MS = inactivityWarningTimeInSec * 1000;
            const TOTAL_ALLOWED_TIME_MS = TIMEOUT_MS + WARNING_DURATION_MS;

            if (now - lastActivity >= TOTAL_ALLOWED_TIME_MS) {
              localStorage.removeItem("lastActivity");
              await authService.logOut();
              dispatch({ type: "Reset" });
              dispatch(removeAuthInfo());

              setIsLoading(false);
              return;
            }
          }
          await authService.fetchLoggedUserData(currentUser, currentUser.email);
          setIsLoading(false);
        } else {
          if (!isError) {
            dispatch({ type: "Reset" });
          }
          setIsLoading(false);
        }
      }
    );

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <FullCircularLoader loading={isLoading} />;
  }

  const hasUser = auth?.user && Object.keys(auth.user).length > 0;

  if (!hasUser) {
    return <Navigate to={LOGIN} />;
  }

  // If authorized render the page requested
  return (
    <Layout>
      <Suspense fallback={<></>}>
        <Outlet />
      </Suspense>
    </Layout>
  );
}

export default ProtectedRoute;
